import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=5777c954&scoped=true&"
import script from "./BaseCard.vue?vue&type=script&lang=ts&"
export * from "./BaseCard.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=5777c954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5777c954",
  null
  
)

export default component.exports